import { render, staticRenderFns } from "./cPie.vue?vue&type=template&id=567bd043&scoped=true&"
import script from "./cPie.vue?vue&type=script&lang=js&"
export * from "./cPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567bd043",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567bd043')) {
      api.createRecord('567bd043', component.options)
    } else {
      api.reload('567bd043', component.options)
    }
    module.hot.accept("./cPie.vue?vue&type=template&id=567bd043&scoped=true&", function () {
      api.rerender('567bd043', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/cPie.vue"
export default component.exports